export enum InspectionTypeEnum {
  VEHICLE = 'VEHICLE',
  AGRICULTURAL_MACHINE =  'AGRICULTURAL_MACHINE',
  VESSEL = 'VESSEL'
}
